import React from 'react';

const Plate = ({ value, small, style }) => {
    const isSmall = small || false;

    return (
        <span style={{
            fontFamily: "'Courier New', Courier, monospace",
            fontSize: isSmall ? '11px' : '13px',
            padding: isSmall ? '1px 3px' : '2px 6px',
            background: 'linear-gradient(180deg, #ffc107 0%, #ffb100 100%)',
            color: '#000000',
            borderRadius: isSmall ? '3px' : '4px',
            border: '1px solid rgba(0,0,0,0.3)',
            fontWeight: '900',
            boxShadow: isSmall ? '0 1px 2px rgba(0,0,0,0.1)' : '0 2px 4px rgba(0,0,0,0.2)',
            display: 'inline-flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            letterSpacing: '-0.3px',
            lineHeight: '1',
            textTransform: 'uppercase',
            maxWidth: 'fit-content',
            ...style
        }}>
            {value ? String(value).trim() : '—'}
        </span>
    );
};

export default Plate;
